/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Volume_TitleInputs */

const en_ui_volume_title = /** @type {(inputs: Ui_Volume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

const de_ui_volume_title = /** @type {(inputs: Ui_Volume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfang`)
};

/**
* | output |
* | --- |
* | "Volume" |
*
* @param {Ui_Volume_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_volume_title = /** @type {((inputs?: Ui_Volume_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Volume_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_volume_title(inputs)
	return de_ui_volume_title(inputs)
});